import type { PokemonStatusTag, calcOtherSetting } from '../../types/pokemon';

// 状態タグを重複排除し、空なら未設定扱いにする
const normalizePokemonStatuses = (
  statuses?: PokemonStatusTag[],
): PokemonStatusTag[] | undefined => {
  if (!statuses || statuses.length === 0) {
    return undefined;
  }

  return Array.from(new Set(statuses));
};

// 状態異常タグで指定状態を判定
export const hasPokemonStatus = (
  settings: calcOtherSetting | undefined,
  status: PokemonStatusTag,
): boolean => {
  if (!settings) {
    return false;
  }

  if (settings.statusTags?.includes(status)) {
    return true;
  }

  return false;
};

// 状態異常タグをオン/オフする
export const setPokemonStatus = (
  settings: calcOtherSetting | undefined,
  status: PokemonStatusTag,
  enabled: boolean,
): calcOtherSetting => {
  const currentStatuses = new Set(settings?.statusTags ?? []);

  if (enabled) {
    currentStatuses.add(status);
  } else {
    currentStatuses.delete(status);
  }

  const normalized = normalizePokemonStatuses(Array.from(currentStatuses));

  const nextSetting: calcOtherSetting = {
    ...(settings ?? {}),
  };

  if (normalized) {
    nextSetting.statusTags = normalized;
  } else {
    delete nextSetting.statusTags;
  }

  return nextSetting;
};

// やけど状態をタグ/旧キーで判定する
export const isBurnedStatus = (settings: calcOtherSetting | null | undefined): boolean => {
  const legacySettings = settings as { isBurned?: boolean } | null | undefined;
  return Boolean(settings?.statusTags?.includes('burned') || legacySettings?.isBurned);
};

export const isJuudenStatus = (settings: calcOtherSetting | null | undefined): boolean => {
  const legacySettings = settings as { is_juuden?: boolean } | null | undefined;
  return Boolean(legacySettings?.is_juuden || settings?.statusTags?.includes('juuden'));
};

// どく状態をタグ/旧キーで判定する
export const isPoisonedStatus = (settings: calcOtherSetting | null | undefined): boolean => {
  const legacySettings =
    settings as { isPoisoned?: boolean; is_poisoned?: boolean } | null | undefined;
  return Boolean(
    settings?.statusTags?.includes('poisoned') ||
      legacySettings?.isPoisoned ||
      legacySettings?.is_poisoned,
  );
};
